export default function Url(props) {
    return (
        <a className={'dotted-underline '+ (props.colorize ? "text-primary " : "") + (props.className ? props.className : "")} href={props.href} target="_blank">{props.children}</a>
    );
}